declare global {
  interface Window {
    APP_CONFIG?: Record<string, string>;
  }
}

const getRuntimeConfig = (): Record<string, string> => window.APP_CONFIG || {};

export const getConfigValue = (key: string, fallback = ''): string => {
  const runtimeValue = getRuntimeConfig()[key];

  if (runtimeValue !== undefined && runtimeValue !== null && runtimeValue !== '') {
    return runtimeValue;
  }

  return process.env[key] || fallback;
};
